import React, { useEffect, useState } from "react";
import { Modal, Select, Input, Button, Typography } from "antd";
import toast from "react-hot-toast";
import { generateToken, messaging } from "../../../firebase/firebase";
import { onMessage } from "firebase/messaging";
import { set } from "date-fns";
import { createWarning } from "../../../services";
const { Option } = Select;
const { TextArea } = Input;

const WarningModal = ({
  show,
  onCancel,
  title, // "student" or "teacher"
  list = [],
  onSubmit,
}) => {
  const [type, setType] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [description, setDescription] = useState("");
  const [messageObj, setMessageObj] = useState();
  const [loading, setLoading] = useState(false);

  const handleSend = async () => {
    if (!type || !selectedUser || !description) {
      // return alert('Please fill all fields');
      toast.error("Please fill all fields");
      return;
    }
    setLoading(true);
    setMessageObj(null);

    console.log("selectedUser", selectedUser);

    const formData = {
      type,
      description,
      role: title,
      receiverId: selectedUser,
    };

    try {
      // eslint-disable-next-line
      const warningId = await createWarning(formData);
      toast.success("Warning created successfully!");
      setSelectedUser("");
      setType("");
      setDescription("");
    } catch (error) {
      toast.error("Error creating warning: " + error.message);
    } finally {
      setLoading(false);
    }

    onSubmit({
      role: title,
      type,
      user: selectedUser,
      description,
    });
    // Clear fields
    setType("");
    setSelectedUser("");
    setDescription("");
  };

  useEffect(() => {
    // Initialize FCM and request permission
    if (selectedUser) {
      generateToken(selectedUser);
    }

    // Listen for foreground messages
    const unsubscribe = onMessage(messaging, (payload) => {
      console.log("Foreground message received:", payload);
      setMessageObj(payload);

      // Show browser notification if permission granted
      if (Notification.permission === "granted") {
        new Notification(payload.notification.title, {
          body: payload.notification.body,
          icon: payload.notification.icon || "/notification-icon.png",
          tag: payload.data?.warningId || "warning-notification",
        });
      }
    });

    return () => unsubscribe();
  }, [selectedUser]);

  return (
    <Modal
      open={show}
      onCancel={onCancel}
      footer={null}
      title={`Create ${
        title.charAt(0).toUpperCase() + title.slice(1)
      } Notification`}
    >
      <div className="space-y-5">
        {/* Type */}
        <div className="mb-2">
          <Typography.Text strong>Type</Typography.Text>
          <div style={{ marginTop: 8 }}>
            <Select
              value={type}
              onChange={setType}
              placeholder="Select type"
              style={{ width: "100%" }}
            >
              <Option value="Warning">Warning</Option>
              <Option value="Update">Update</Option>
              <Option value="Reminder">Reminder</Option>
              <Option value="Attendance Issue">Attendance Issue</Option>
              <Option value="Behavior Warning">Behavior Warning</Option>
              <Option value="Academic Concern">Academic Concern</Option>
              <Option value="Disciplinary Action">Disciplinary Action</Option>
              <Option value="General Notice">General Notice</Option>
            </Select>
          </div>
        </div>

        {/* User */}
        <div className="mb-2">
          <Typography.Text strong>
            Select a {title.charAt(0).toUpperCase() + title.slice(1)}
          </Typography.Text>
          <div style={{ marginTop: 8 }}>
            <Select
              value={selectedUser}
              onChange={setSelectedUser}
              placeholder={`Select a ${title}`}
              style={{ width: "100%" }}
            >
              {list.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.fullName}
                </Option>
              ))}
            </Select>
          </div>
        </div>

        {/* Description */}
        <div className="mb-2">
          <Typography.Text strong>Description</Typography.Text>
          <div style={{ marginTop: 8 }}>
            <TextArea
              rows={4}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Write something..."
            />
          </div>
        </div>

        {/* Buttons */}
        <div className="d-flex justify-content-end gap-2">
          <Button
            onClick={onCancel}
            className="btn btn_contained_black fs_12 btn-sm text-white px-3"
          >
            Cancel
          </Button>
          <Button
            type="primary"
            onClick={handleSend}
            className="btn btn_contained_black fs_12 btn-sm text-white px-3"
          >
            Send
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default WarningModal;
